<template>
	<div class="content">
		<el-row type="flex" style="height: 150px;padding-top: 25px;">
			<el-col :span="5">
				<el-row class="bigtitle">友情链接</el-row>
				<el-row>
					<el-col :span="24" class="title" v-for="(item, index) in linkList" v-if="index < 3" :key="index">
						<div style="cursor: pointer;" @click="goHref(item.href)">{{ item.title }}</div>
					</el-col>
				</el-row>
				<el-row v-if="morelinkList.length > 0">
					<el-col :span="24" class="title">
						<el-select v-model="value" placeholder="更多" size="small" @change="goHref($event)">
							<el-option v-for="(item, index) in morelinkList" :key="index" :label="item.title" :value="item.href"></el-option>
						</el-select>
					</el-col>
				</el-row>
			</el-col>
			<el-col :span="5">
				<el-row class="bigtitle">快捷入口</el-row>
				<el-row>
					<el-col :span="8" class="title" v-for="(item, index) in fastLink" :key="index"><div style="cursor: pointer;" @click="goHref(item.href)">{{ item.title }}</div></el-col>
				</el-row>
			</el-col>
			<el-col :span="10">
				<el-row class="bigtitle">联系我们</el-row>
				<el-row>
					<el-col :span="10" class="title">服务热线：{{baseInfo.hotLine}}</el-col>
					<el-col :span="14" class="title">建设与运营咨询：{{baseInfo.consultLine}}</el-col>
				</el-row>
				<el-row>
					<el-col :span="10" class="title">技术支持：{{baseInfo.serviceLine}}</el-col>
					<el-col :span="14" class="title">邮箱：{{baseInfo.email}}</el-col>
				</el-row>
				<el-row><el-col :span="24" class="title">注册地址：{{baseInfo.registAddress}}</el-col></el-row>
			</el-col>
			<el-col :span="4">
				<el-row type="flex" align="middle">
					<el-col style="text-align: center;">
						<el-image style="width: 90px; height: 90px" :src="require('../../static/code.jpg')" fit="fill"></el-image>
						<div class="title">微信二维码</div>
					</el-col>
				</el-row>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import { linkList, baseInfo,fastLink } from '@/api';
export default {
	name: 's-footer',
	data() {
		return {
			value: '',
			linkList: [], //友情连接
			morelinkList: [] ,//友情连接 下拉框
			fastLink: [], //快捷入口
			baseInfo:{ //联系我们
				hotLine:'',//服务热线
				consultLine:'',//咨询
				serviceLine:'',//技术支持
				email:'',//邮箱
				registAddress:''//注册地址
			},
		};
	},
	mounted() {
		this.getLinkList(); //友情链接
		this.getFastLink(); //快捷入口
		this.getBaseInfo(); //联系我们
	},
	methods: {
		//友情链接
		getLinkList() {
			let _this = this;
			fastLink().then(res => {
				_this.fastLink = res.data;
			});
		},
		//快捷入口
		getFastLink() {
			let _this = this;
			linkList().then(res => {
				_this.linkList = res.data;
				if (res.data.length > 3) {
					_this.morelinkList = res.data.slice(3);
				}
			});
		},
		//联系我们
		getBaseInfo() {
			let _this = this;
			baseInfo().then(res => {
				_this.baseInfo = res.data;
				localStorage.setItem('showHightTalentImg',res.data.showHightTalentImg);
			});
		},
		goHref(url) {
			window.open(url, '_blank');
		}
	}
};
</script>
<style>
.el-footer .el-input__inner {
	background-color: #6d7177;
	border: 1px solid #9399a2;
	border-radius: 2px;
	color: #a0a0a0;
}
.title a {
	text-decoration: none;
	color: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue